export const FETCH_LOGBUILD_AUTH_SUCCESS = "FETCH_LOGBUILD_AUTH_SUCCESS";
export const FETCH_LOGBUILD_STAFF_SUCCESS = "FETCH_LOGBUILD_STAFF_SUCCESS";
export const POST_LOGBUILD_STAFF_SUCCESS = "POST_LOGBUILD_STAFF_SUCCESS";
export const FETCH_LOGBUILD_STAFF_DETAIL_SUCCESS =
  "FETCH_LOGBUILD_STAFF_DETAIL_SUCCESS";
export const PUT_LOGBUILD_STAFF_SUCCESS = "PUT_LOGBUILD_STAFF_SUCCESS";
export const DELETE_LOGBUILD_STAFF_SUCCESS = "DELETE_LOGBUILD_STAFF_SUCCESS";
export const PUT_PASSWORD_LOGBUILD_SUCCESS = "PUT_PASSWORD_LOGBUILD_SUCCESS";
